import Link from 'next/link';
import { Fragment, useEffect, useState } from 'react';
import ArrowDown from 'components/Svg/ArrowDown';
import { useRouter } from 'next/router';
import styles from 'styles/modules/Breadcrumb.module.scss';

const Breadcrumb = () => {
    const router = useRouter();
    const [links, setLinks] = useState(null);

    useEffect(() => {
        const paths = router.asPath.split('/').filter(Boolean);
        // paths.shift(); // used .filter(Boolean) instead
        const newPaths = [];

        paths.forEach((item, index) => {
            newPaths.push(`${newPaths[index - 1] || ''}` + `/${item}`);
        });
        setLinks(newPaths);
    }, []);

    // if (!router.query?.company) {
    //     return null;
    // }

    return (
        links?.length > 1 && (
            <nav
                className={[
                    'mb-l',
                    styles.wrapper,
                    // router.asPath.includes('/news-story/') || router.asPath.includes('/news-alerts/') ? 'mb-l' : null,
                ].join(' ')}
            >
                {links?.map((href, index) => {
                    const isLast = index === links.length - 1;

                    let label;

                    // index === 0
                    //     ? 'Newspage'
                    //     : href.split('/')[index + 1].replaceAll('-', ' ');

                    if (index === 0) {
                        if (router.asPath.includes('/news-story/')) {
                            label = 'Newspage'; // TODO: Get company name instead
                        } else {
                            label = 'Newspage';
                        }
                    } else {
                        label = href.split('/')[index + 1].replaceAll('-', ' ');
                    }

                    let item;

                    // if not last item, create a link
                    if (!isLast) {
                        item = (
                            <Link href={href}>
                                <a className={styles.href}>{label}</a>
                            </Link>
                        );
                    }
                    // if last item, create a span
                    else {
                        item = <span className={styles.href}>{label}</span>;
                    }

                    return (
                        <Fragment key={index}>
                            {item}
                            {!isLast && <ArrowDown />}
                        </Fragment>
                    );
                })}
            </nav>
        )
    );
};

export default Breadcrumb;
